import { Fragment, type ReactNode } from 'react'
import { SEARCH_FILTER_TYPE } from '@/features/shared/constants/global'
import { DealsOption } from '@/features/shop/components/ProductFilter/FilterOptions/DealsOption'
import { SortByOption } from '@/features/shop/components/ProductFilter/FilterOptions/SortByOption'
import { CategoryOption } from '@/features/shop/components/ProductFilter/FilterOptions/CategoryOption'
import { type Facet } from '@/features/shop/services/Search/types'
import { BrandFilterOption } from '@/features/shop/components/ProductFilter/BrandFilterOption'
import { FlavorFilterOption } from '@/features/shop/components/ProductFilter/FlavorFilterOption'

type Props = {
  facets: Facet[]
  startIndex: number
  // renders the STORE facet. kept as a render prop so the universal search
  // dependency chain in RetailerFilterOption is only bundled by callers that
  // actually support store filtering (the ungated category flow).
  renderStoreOption?: (index: number) => ReactNode
}

export const FacetOptionsList = ({ facets, startIndex, renderStoreOption }: Props) => {
  const { ACTIVE_DEALS, CATEGORY, BRAND, SORT_BY, STORE, FLAVOR } = SEARCH_FILTER_TYPE

  return (
    <>
      {facets.map((f, i) => {
        const index = startIndex + i

        switch (f.facet) {
          case ACTIVE_DEALS:
            return <DealsOption key={f.facet} index={index} />
          case FLAVOR:
            return <FlavorFilterOption index={index} name={f.name} key={f.facet} items={f.items} />
          case BRAND:
            return <BrandFilterOption index={index} name={f.name} key={f.facet} items={f.items} />
          case CATEGORY:
            return <CategoryOption items={f.items} name={f.name} key={f.facet} index={index} />
          case SORT_BY:
            return <SortByOption index={index} key={f.facet} />
          case STORE:
            return renderStoreOption ? (
              <Fragment key={f.facet}>{renderStoreOption(index)}</Fragment>
            ) : null
          default:
            return null
        }
      })}
    </>
  )
}
